import Vue from 'vue'
import loading from './index.vue'
import variables from '@/assets/styles/variables.scss'
import { lang } from '@/lang'
const textMap = new Map([
  ['zh', '加载中'],
  ['en', 'Loading'],
  ['th', 'กำลังดาวน์โหลด']
])
const options = {
  hide: true,
  text: textMap.get(lang.currentLang),
  themeColor: variables.theme
}
const Load = Vue.extend(loading)
const node = new Load({ data: () => options })
node.$mount()

export default {
  open(el) {
    const parent = el || document.body
    if (!parent.load) {
      parent.load = node
      parent.appendChild(node.$el)
    }
    node.hide = true
  },
  close() {
    options.hide = false
  }
}
